module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-view"
  }, [_vm._l((_vm.videoList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "video-item-view"
    }, [(false) ? _c('el-divider', {
      attrs: {
        "content-position": "center"
      }
    }, [_vm._v("视频信息")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "publisher-view"
    }, [_vm._v("\n      发布人: " + _vm._s(item.platformUserName) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "video-title"
    }, [_vm._v("\n      视频标题: " + _vm._s(item.videoTitle) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "video-title-view"
    }, [_c('div', {
      staticClass: "video-text"
    }, [_vm._v("视频简介: " + _vm._s(item.videoText))])]), _vm._v(" "), _c('div', {
      staticClass: "video-item"
    }, [_c('vueMiniPlayer', {
      ref: "vueMiniPlayer",
      refInFor: true,
      attrs: {
        "video": item.videoItem,
        "mutex": true
      },
      on: {
        "fullscreen": _vm.handleFullscreen
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "video-bottom"
    }, [_c('div', {
      staticClass: "bottom-show-view"
    }, [_c('div', {
      staticClass: "bottom-show-item"
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("平均评分:" + _vm._s(item.starNum))])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-show-item"
    }, [_c('el-tag', {
      attrs: {
        "type": "primary"
      }
    }, [_vm._v("评论数量:" + _vm._s(item.commentNum))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-view"
    }, [_c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-badge', {
      staticClass: "item",
      attrs: {
        "value": item.tagNum
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.videoTag(item)
        }
      }
    }, [_vm._v("点赞")])], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.downloadVideo(item)
        }
      }
    }, [_vm._v("下载视频")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.showCommentView(item)
        }
      }
    }, [_vm._v("评论视频")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.showCommentDrawer(item)
        }
      }
    }, [_vm._v("查看评论")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.showVideoTransmit(item)
        }
      }
    }, [_vm._v("转发视频")])], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-handle-item"
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteVideo(item)
        }
      }
    }, [_vm._v("删除视频")])], 1)])])], 1)
  }), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "视频评论内容",
      "visible": _vm.commentDrawerShow,
      "direction": _vm.commentDrawerDirection,
      "before-close": _vm.handleDrawerClose
    },
    on: {
      "update:visible": function($event) {
        _vm.commentDrawerShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "comment-view"
  }, [_c('el-collapse', {
    on: {
      "change": _vm.handleCommentCollapseChange
    }
  }, _vm._l((_vm.commentList), function(item, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "title": '用户' + item.platformUserName + '在' + item.createTime + '的评论'
      }
    }, [_c('div', {
      staticClass: "star-view"
    }, [_vm._v("视频评分: " + _vm._s(item.starNum))]), _vm._v(" "), _c('div', {
      staticClass: "comment-text-view"
    }, [_vm._v(_vm._s(item.commentText))])])
  }), 1)], 1)]), _vm._v(" "), _c('CommentView', {
    ref: "commentView",
    on: {
      "handleSuccess": _vm.commentSuccess
    }
  }), _vm._v(" "), _c('VideoTransmitView', {
    ref: "videoTransmitView",
    on: {
      "handleSuccess": _vm.transmitVideoSuccess
    }
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-298252d8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298252d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/VideoView.vue
// module id = 1269
// module chunks = 1